/* SPACEREBELS – "Kompletuj wnętrze": dodawanie zestawu do koszyka + filtr pomieszczeń */
(() => {
  if (!window.customElements.get('sr-bundle-add')) {
    class SrBundleAdd extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        this.msg = this.querySelector('[data-msg]');
        this.button?.addEventListener('click', () => this.add());
      }

      setMsg(text, ok) {
        if (!this.msg) return;
        this.msg.textContent = text || '';
        this.msg.className = 'sr-bundle__msg ' + (text ? (ok ? 'sr-bundle__msg--ok' : 'sr-bundle__msg--err') : '');
      }

      async add() {
        let items;
        try { items = JSON.parse(this.dataset.items || '[]'); } catch (e) { items = []; }
        if (!items.length) return;

        const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        const bundleName = this.dataset.bundle || 'Zestaw';
        this.button.setAttribute('aria-busy', 'true');
        this.setMsg('');

        // Impact zbiera tu sekcje do odświeżenia (np. szufladę koszyka)
        const sections = [];
        document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections } }));

        try {
          const response = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({
              items: items.map((i) => ({ id: i.id, quantity: i.qty || 1, properties: { _zestaw: bundleName } })),
              sections: sections.join(',')
            })
          });
          const json = await response.json();

          if (!response.ok) {
            this.setMsg(json.description || json.message || 'Nie udało się dodać zestawu. Spróbuj ponownie.', false);
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            return;
          }

          const cartType = window.themeVariables?.settings?.cartType;
          if (cartType === 'page' || cartType === 'page_redirect') {
            window.location.href = `${root}cart`;
            return;
          }

          const cart = await (await fetch(`${root}cart.js`)).json();
          cart.sections = json.sections;

          this.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: { items: json.items || [], cart } }));
          document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart } }));
          this.setMsg(this.dataset.successText || 'Zestaw jest w koszyku!', true);
        } catch (e) {
          this.setMsg('Błąd połączenia. Spróbuj ponownie.', false);
        } finally {
          this.button.removeAttribute('aria-busy');
        }
      }
    }
    window.customElements.define('sr-bundle-add', SrBundleAdd);
  }

  if (!window.customElements.get('sr-bundle-filter')) {
    class SrBundleFilter extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', (e) => {
          const chip = e.target.closest('[data-room]');
          if (!chip) return;
          const room = chip.dataset.room;
          this.querySelectorAll('[data-room]').forEach((c) => c.setAttribute('aria-pressed', String(c === chip)));
          const grid = document.getElementById(this.getAttribute('aria-controls'));
          grid?.querySelectorAll('[data-bundle-room]').forEach((card) => {
            const rooms = (card.dataset.bundleRoom || '').split('|');
            card.hidden = room !== '*' && !rooms.includes(room);
          });
        });
      }
    }
    window.customElements.define('sr-bundle-filter', SrBundleFilter);
  }
})();
